import {connect} from 'react-redux'
import {selectSalesOrder} from '../../state/detail/selector'
import SalesOrderOverviewWidget from './SalesOrderOverviewWidget'
import {selectFreshSalesCalendlyLink, selectFreshSalesDealOwner} from '../../../process/state/instance-detail/selector'

const mapStateToProps = (state, props) => {
    return {
        salesOrder: selectSalesOrder(state),
        dealOwner: selectFreshSalesDealOwner(state),
        calendlyLink: selectFreshSalesCalendlyLink(state)
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderOverviewWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/SalesOrderOverviewWidgetContainer.js